/**
 * Generates an RFC4122 v4 compliant UUID for use as an Idempotency-Key.
 * Guaranteed format: A-Z a-z 0-9 _ - and well within the 200 character limit.
 */
export function generateIdempotencyKey(): string {
  if (
    typeof window !== 'undefined' &&
    window.crypto &&
    typeof window.crypto.randomUUID === 'function'
  ) {
    return window.crypto.randomUUID();
  }

  // RFC4122 v4 UUID fallback for environments where crypto.randomUUID is unavailable
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
